import React from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'

/**
 * Schedule Button Component
 * Handles button display with tooltip for unavailable slots
 */
const ScheduleButton = ({
  buttonText,
  isDisabled,
  hasUnavailableSlots,
  unavailableTooltip = 'Coach is not available, please change it first',
  onClick,
  isLoading,
}) => {
  if (isDisabled && hasUnavailableSlots && !isLoading) {
    return (
      <OverlayTrigger
        placement='top'
        overlay={
          <Tooltip id='schedule-all-tooltip'>{unavailableTooltip}</Tooltip>
        }>
        <span className='d-inline-block'>
          <Button
            variant='abroad-blue'
            size='md'
            onClick={onClick}
            disabled={true}>
            {buttonText}
          </Button>
        </span>
      </OverlayTrigger>
    )
  }

  return (
    <Button
      variant='abroad-blue'
      size='md'
      onClick={onClick}
      disabled={isDisabled || isLoading}>
      {buttonText}
    </Button>
  )
}

export default ScheduleButton
